export default "__VITE_ASSET__9e7ebbfc__"